import * as React from "react";

import { TriggerTemplateCatalog } from "../templateCatalog";
import { type PlatformEventType } from "../TriggerV2Record";

import { useEventSamples } from "./useEventSamples";

/**
 * The template vocabulary for a trigger subscribed to ``events``: the paths
 * shared by all of them, with sample values. Empty and unloaded until the
 * event samples arrive (fetched once per session).
 */
export function useTriggerTemplateCatalog(
  events: readonly PlatformEventType[],
): TriggerTemplateCatalog {
  const samplesQuery = useEventSamples();
  const samples = samplesQuery.data?.samples;
  // Keyed on the event list's contents rather than its identity: callers
  // often rebuild the array each render.
  const eventsKey = events.join(",");
  return React.useMemo(
    () =>
      samples === undefined
        ? TriggerTemplateCatalog.empty()
        : TriggerTemplateCatalog.fromSamples(
            samples,
            eventsKey.length === 0
              ? []
              : (eventsKey.split(",") as PlatformEventType[]),
          ),
    [samples, eventsKey],
  );
}
